import { createReducer, on } from '@ngrx/store'
import * as ForFundingActions from './for-funding.actions'
import { LinkingForFundingState } from './for-funding.state'

export const initialState: LinkingForFundingState = {}

export const forFundingReducer = createReducer(
   initialState,
   on(ForFundingActions.openForFundingSearch, (state) => ({ ...state, isSearchOpen: true })),
   on(ForFundingActions.closeForFundingSearch, (state) => ({ ...state, isSearchOpen: false })),
   on(ForFundingActions.searchForFundingData, (state) => ({
      ...state,
      data: undefined,
      isLoading: true,
      needReload: undefined,
      fundingDetail: undefined,
   })),
   on(ForFundingActions.searchForFundingDataSuccess, (state, action) => ({
      ...state,
      data: action.data,
      isLoading: undefined,
      needReload: undefined,
   })),
   on(ForFundingActions.searchForFundingDataFailure, (state, action) => ({
      ...state,
      data: undefined,
      isLoading: undefined,
      needReload: undefined,
   })),
   on(ForFundingActions.downloadForFundingData, (state) => ({
      ...state,
      isDownloadLoading: true,
   })),
   on(ForFundingActions.downloadForFundingDataSuccess, (state) => ({
      ...state,
      isDownloadLoading: undefined,
   })),
   on(ForFundingActions.downloadForFundingDataFailure, (state, action) => ({
      ...state,
      isDownloadLoading: undefined,
   })),

   on(
      ForFundingActions.addForFundingComment,
      ForFundingActions.addForFundingPartner,
      ForFundingActions.editForFundingPartner,
      ForFundingActions.addForFundingResponsible,
      ForFundingActions.addForFundingCoordinator,
      ForFundingActions.editForFundingCoordinator,
      ForFundingActions.deleteForFundingComment,
      ForFundingActions.deleteForFundingPartner,
      ForFundingActions.deleteForFundingResponsible,
      ForFundingActions.deleteForFundingCoordinator,
      ForFundingActions.saveSoughtPartnerAndSendNotification,
      ForFundingActions.sendJustNotificationForSoughtPartner,
      (state) => ({
         ...state,
         needReload: undefined,
         isLoading: true,
      })
   ),

   on(
      ForFundingActions.addForFundingPartnerSuccess,
      ForFundingActions.addForFundingCommentSuccess,
      ForFundingActions.addForFundingResponsibleSuccess,
      ForFundingActions.addForFundingCoordinatorSuccess,
      ForFundingActions.editForFundingCoordinatorSuccess,
      ForFundingActions.editForFundingPartnerSuccess,
      ForFundingActions.addForFundingPNOResponsibleSuccess,
      ForFundingActions.deleteForFundingCommentSuccess,
      ForFundingActions.deleteForFundingPartnerSuccess,
      ForFundingActions.deleteForFundingResponsibleSuccess,
      ForFundingActions.deleteForFundingCoordinatorSuccess,
      ForFundingActions.saveSoughtPartnerAndSendNotificationSuccess,
      ForFundingActions.sendJustNotificationForSoughtPartnerSuccess,

      (state) => ({
         ...state,
         needReload: true,
      })
   ),
   on(
      ForFundingActions.addForFundingCommentFailure,
      ForFundingActions.addForFundingPartnerFailure,
      ForFundingActions.editForFundingPartnerFailure,
      ForFundingActions.addForFundingResponsibleFailure,
      ForFundingActions.addForFundingCoordinatorFailure,
      ForFundingActions.editForFundingCoordinatorFailure,
      ForFundingActions.addForFundingPNOResponsibleFailure,
      ForFundingActions.deleteForFundingCommentFailure,
      ForFundingActions.deleteForFundingPartnerFailure,
      ForFundingActions.deleteForFundingResponsibleFailure,
      ForFundingActions.deleteForFundingCoordinatorFailure,
      ForFundingActions.saveSoughtPartnerAndSendNotificationFailure,
      ForFundingActions.sendJustNotificationForSoughtPartnerFailure,

      (state) => ({
         ...state,
         needReload: undefined,
         isLoading: undefined,
      })
   ),
   on(ForFundingActions.resetForFundingState, () => ({})),

   on(ForFundingActions.setForFundingSearchFields, (state, action) => ({
      ...state,
      searchFields: action.searchFields,
   })),
   on(ForFundingActions.getFundingDataByID, (state) => ({
      ...state,
      fundingDetail: undefined,
      isLoadingFundingDetail: true,
   })),
   on(ForFundingActions.getFundingDataByIDSuccess, (state, action) => ({
      ...state,
      fundingDetail: action.data,
      isLoadingFundingDetail: undefined,
   })),
   on(ForFundingActions.getFundingDataByIDFailure, (state, action) => ({
      ...state,
      isLoadingFundingDetail: undefined,
   })),
   on(ForFundingActions.setItemIdToScroll, (state, action) => ({
      ...state,
      itemToScroll: {
         id: action.id,
         isPartnerToScroll: action.isPartnerToScroll,
         isCoordinatorToScroll: action.isCoordinatorToScroll,
         isCommentsToScroll: action.isCommentsToScroll,
      },
   })),
   // seeking partners
   on(ForFundingActions.getSoughtPartners, (state) => ({
      ...state,
      soughtPartnersData: undefined,
      isLoadingSoughtPartners: true,
   })),
   on(ForFundingActions.getSoughtPartnersSuccess, (state, action) => ({
      ...state,
      soughtPartnersData: action.data,
      isLoadingSoughtPartners: undefined,
   })),
   on(ForFundingActions.getSoughtPartnersFailure, (state) => ({
      ...state,
      isLoadingSoughtPartners: undefined,
   })),
   on(ForFundingActions.addSoughtPartner, (state, action) => ({
      ...state,
      soughtPartnersData: state.soughtPartnersData ? [...state.soughtPartnersData, action.body] : [action.body],
   })),
   on(ForFundingActions.replaceSoughtPartner, (state, action) => ({
      ...state,
      soughtPartnersData: (() => {
         const currentData = state.soughtPartnersData ?? []
         if (action.index < 0 || action.index >= currentData.length) return currentData

         return currentData.map((partner, index) => (index === action.index ? action.body : partner))
      })(),
   })),
   on(ForFundingActions.removeSoughtPartner, (state, action) => ({
      ...state,
      soughtPartnersData: (() => {
         const currentData = state.soughtPartnersData ?? []
         if (action.index < 0 || action.index >= currentData.length) return currentData

         return currentData.filter((_, index) => index !== action.index)
      })(),
   })),
   on(ForFundingActions.cleanSoughtPartnersData, (state) => ({
      ...state,
      soughtPartnersData: undefined,
   }))
)
